import{useSelector}from'react-redux';const useSystemMessage=()=>{return useSelector(state=>state.systemMessage);};export default useSystemMessage;